import { CamelCaseKeys } from '@utils/typescript';
import { InsuranceTypesEnum } from '@models/InsuranceType';
import { tEnum } from '../components/i18n';
import { UserLess } from './User';
import { InsurancePolicyUserLess } from './InsurancePolicyUser';

export enum BillingTypes {
  Reimbursement = 'reimbursement',
  DirectBilling = 'direct_billing'
}

export enum BillingTypeCodes {
  Reimbursement = 'RI',
  DirectBilling = 'DB'
}

export const BillingTypeCodeToTypeMapping = {
  [BillingTypeCodes.Reimbursement]: BillingTypes.Reimbursement,
  [BillingTypeCodes.DirectBilling]: BillingTypes.DirectBilling,
};

export enum ClaimStatuses {
  Pending = 'pending',
  InReview = 'in_review',
  InProgress = 'in_progress',
  Approved = 'approved',
  PaymentProcessing = 'payment_processing',
  Closed = 'closed',
  Voided = 'voided',
  SettlementOffered = 'settlement_offered'
}

export enum ClaimableTypes {
  Car = 'CarClaim',
  PersonalAccident = 'PersonalAccidentClaim',
  Cancer = 'CancerClaim',
  Health = 'HealthClaim',
}

export type InsuranceClaimList = CamelCaseKeys<{
  id: number;
  claimable_id: number;
  claimable_type: ClaimableTypes;
  insurance_type: InsuranceTypesEnum;
  order_number: string;
  policy_number: string;
  claim_number: string;
  status: ClaimStatuses;
  billing_type_code: string;
  created_at: number;
  total_claimed_amount: NumericString;

  creator: UserLess;
  insurance_policy_user: InsurancePolicyUserLess;
}>;

export type InsuranceClaim = InsuranceClaimList &
  CamelCaseKeys<{
    note: string;
    approved_amount: number;
  }>;

const CLAIM_STATUSES_VARIANTS_MAPPING = {
  [ClaimStatuses.Pending]: 'primary',
  [ClaimStatuses.InReview]: 'info',
  [ClaimStatuses.InProgress]: 'info',
  [ClaimStatuses.Approved]: 'success',
  [ClaimStatuses.PaymentProcessing]: 'secondary',
  [ClaimStatuses.Closed]: 'dark',
  [ClaimStatuses.Voided]: 'danger',
  [ClaimStatuses.SettlementOffered]: 'warning',
};

export const getClaimStatusVariant = (status: ClaimStatuses) => {
  return CLAIM_STATUSES_VARIANTS_MAPPING[status];
};

export const tClaimStatus = (status: ClaimStatuses) => tEnum('insuranceClaimStatuses', status);
